<template>
  <div>
    <PublicShell :igreja="igreja" titulo="Cadastro de Profissional" :valido="!!igrejaId" max-width="720px">
      <p class="pub-intro">Dados do membro:</p>
      <v-container fluid grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 sm12 lg12>
            <v-text-field light label="CPF*" color="#00695C" outlined v-mask="'###.###.###-##'" dense hide-details type="tel" v-model="membro.cpf" @change="consultaCPF(membro.cpf)" append-outer-icon="search"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg8>
            <v-text-field light disabled v-model="membro.nome" label="NOME" outlined color="#00695C" dense hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg4>
            <v-text-field light disabled v-model="membro.celula" label="CÉLULA" outlined color="#00695C" dense hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg12>
            <p class="pub-intro mt-2">Informe os serviços:</p>
          </v-flex>
          <v-flex xs12 sm12 lg12 v-if="!existeProfissional">
            <v-autocomplete outlined dense :disabled="!membro.nome" v-model="profissional.servicos" :items="servicos" hide-details item-text="nome" item-value="codigo" color="#00695C" label="SERVIÇOS" no-data-text="Sua igreja ainda não cadastrou serviços" multiple @input="searchInput = null" :search-input.sync="searchInput"></v-autocomplete>
          </v-flex>
          <v-flex xs9 sm9 lg10 v-if="existeProfissional">
            <v-autocomplete outlined dense v-model="servicoSelecionado" :items="servicos" hide-details item-text="nome" item-value="codigo" color="#00695C" label="SERVIÇOS" no-data-text="Sua igreja ainda não cadastrou serviços" @input="searchInput = null" :search-input.sync="searchInput"></v-autocomplete>
          </v-flex>
          <v-flex xs3 sm3 lg2 v-if="existeProfissional">
            <v-btn block color="success" @click="adicionaItensRestritos">Add</v-btn>
          </v-flex>
          <v-flex xs12 sm12 lg12 v-if="existeProfissional">
            <v-data-iterator :items="profissional.servicos" :items-per-page.sync="iterador.itensPorPagina" hide-default-footer>
              <template v-slot:no-data>
                <v-alert class="mt-5 mb-0" type="info" dense text>Nenhum serviço adicionado</v-alert>
              </template>
              <template v-slot:default="props">
                <v-row dense>
                  <v-col v-for="item in props.items" :key="item.name" cols="12">
                    <v-card outlined>
                      <v-list dense style="padding: 0px">
                        <v-list-item>
                          <v-list-item-content style="padding: 0px">
                            <v-list-item-title>{{ nomeProfissao(item) }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-list-item-subtitle>
                              <v-btn icon @click="removeItem(item)"><v-icon>delete</v-icon></v-btn>
                            </v-list-item-subtitle>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </v-flex>
        </v-layout>
      </v-container>

      <v-btn dark depressed block color="#00695C" rounded large class="mt-5" @click="salvaProfissional">Confirmar Cadastro</v-btn>
    </PublicShell>

    <v-dialog v-model="dialogoCadastroConcluido" persistent max-width="500px">
          <v-card>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="success" size="100">check_circle</v-icon>
                    <p class="pp-texto" style="color:#00695C">Cadastro realizado com sucesso!</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="closeDialog">Concluir</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoNaoCadastrado" persistent max-width="500px">
          <v-card>
            <v-card-title>Atenção</v-card-title>
            <v-card-text style="padding-bottom: 0px">
              <v-container>
                <v-row dense>
                  <v-col cols="12" style="text-align: center; padding: 2px;">
                    <v-icon left color="warning" size="100">warning</v-icon>
                    <p class="pp-texto" style="color: #666">O CPF informado não possui cadastro na <strong>{{ igreja.nome }}</strong>. <a :href="`/cadastro-membro?igrejaId=${igrejaId}`">Clique aqui</a> e cadastre-se primeiro.<br><br>Depois, tente novamente.</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dialogoNaoCadastrado = false">Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref="chamaSnackbar" />
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { baseApiUrl } from '@/global'
import Snackbar from '../../componentes/snackbar.vue'
import axios from 'axios'
import PublicShell from '../../componentes/PublicShell.vue'

export default {
  name: 'CadastroProfissionalPublico',
  components: { Snackbar, Loading, PublicShell },
  data() {
    return {
      igrejaId: '',
      igreja: {},
      membro: { nome: '', celula: '', cpf: '' },
      profissional: { membroId: '', igrejaId: '', servicos: [] },
      iterador: { itensPorPagina: -1 },
      celulas: [],
      servicos: [],
      searchInput: null,
      dialogoNaoCadastrado: false,
      dialogoCadastroConcluido: false,
      isLoading: false,
      fullPage: true,
      existeProfissional: false,
      servicoSelecionado: '',
    }
  },
  mounted() {
    this.igrejaId = this.$route.query.igrejaId || ''
    if (this.igrejaId) {
      this.carregaDados()
      this.carregaCelulas()
    }
  },
  watch: {
    dialogoNaoCadastrado(val) { if (val === false) window.location.reload() },
  },
  methods: {
    async carregaDados() {
      this.isLoading = true
      try {
        const response = await axios.post(baseApiUrl + 'Igrejas/infoPublica', null, { params: { igrejaId: this.igrejaId } })
        if (response.data) {
          this.igreja = response.data
          this.profissional.igrejaId = response.data.id
        }
      } catch (error) {
        this.igrejaId = ''
      } finally {
        this.isLoading = false
      }
    },
    async carregaCelulas() {
      try {
        const response = await axios.post(baseApiUrl + 'Celulas/listarPublicas', null, { params: { igrejaId: this.igrejaId } })
        if (response.data) this.celulas = response.data
      } catch (e) { this.celulas = [] }
    },
    async consultaCPF(cpf) {
      if (!cpf) return
      this.isLoading = true
      try {
        const response = await axios.post(baseApiUrl + 'Membros/buscaPublicaCpf', null, { params: { cpf: cpf, igrejaId: this.igrejaId } })
        if (response.data && response.data.id) {
          this.membro.nome = response.data.nome
          this.membro.celula = response.data.celula && response.data.celula.nome
            ? response.data.celula.nome
            : this.nomeCelula(response.data.celulaId)
          this.profissional.membroId = response.data.id
          await this.carregaProfissoes()
          await this.verificaProfissional(response.data.id)
        } else {
          this.dialogoNaoCadastrado = true
        }
      } catch (e) {
        this.$refs.chamaSnackbar.snack('#EF5350', 'Erro ao consultar o CPF. Tente novamente.', 'ERRO')
      } finally {
        this.isLoading = false
      }
    },
    async verificaProfissional(id) {
      await axios.post(baseApiUrl + 'Profissionais/buscarPorMembroPublico', { membroId: id })
        .then(response => {
          if (response.data.length > 0) {
            this.existeProfissional = true
            this.profissional.servicos = response.data[0].servicos
            this.profissional.id = response.data[0].id
          }
        })
    },
    closeDialog() { window.location.reload() },
    async salvaProfissional() {
      const vm = this
      if (!this.profissional.membroId || this.profissional.servicos.length === 0) {
        vm.$refs.chamaSnackbar.snack('#F9A825', 'Preencha todos os campos para continuar!', 'ATENÇÃO')
      } else {
        this.isLoading = true
        this.profissional.igrejaId = this.igreja.id
        let response = await axios.post(baseApiUrl + 'Profissionais/salvarPublico', this.profissional)
        if (response.data) {
          this.dialogoCadastroConcluido = true
          this.isLoading = false
        }
      }
    },
    nomeCelula(celulaId) {
      let nome
      this.celulas.filter(celula => { if (celula.id === celulaId) nome = celula.nome.trim() })
      return nome
    },
    nomeProfissao(codigo) {
      let nome
      this.servicos.filter(s => { if (s.codigo === codigo) nome = s.nome.trim() })
      return nome
    },
    async carregaProfissoes() {
      await axios.post(baseApiUrl + 'ServicoProfissionals/listarPublicos', { igrejaId: this.igreja.id })
        .then(response => { if (response.data.length > 0) this.servicos = response.data })
    },
    adicionaItensRestritos() {
      const vm = this
      if (!this.servicoSelecionado) {
        vm.$refs.chamaSnackbar.snack('#F9A825', 'Necessário escolher um serviço!', 'ATENÇÃO')
      } else {
        this.profissional.servicos.push(this.servicoSelecionado)
        this.servicoSelecionado = ''
      }
    },
    removeItem(item) {
      this.profissional.servicos = this.profissional.servicos.filter(s => s !== item)
    },
  },
}
</script>

<style scoped>
.pub-intro { color: #5b6b67; margin: 0 0 6px; font-size: .95rem; }
.pp-texto { font-weight: bold; color: #00253E; font-size: 17px; }
</style>
